export default __webpack_public_path__ + "robto_computer.png";